let detected = false;
let result: boolean;

/**
 * @returns a boolean indicating if the user is in the AppShell mode or in the regular (data page embed via service) mode.
 */
export function isAppShell() {
    if (detected) {
        return result;
    }

    result = !!document.getElementById('AppShellEnabled');
    detected = true;

    return result;
}
